import { useQuery } from '@tanstack/react-query';

import { CustomNotification } from 'common/components';

import { getAPLGrid } from 'services/product';

export const APL_KEY = {
  getAplGrid: (page = 'product-grid') => ['apl', 'get-apl-grid', { page }],
};

export const useGetAPLGrid = ({ params, key, ...rest }) =>
  useQuery({
    queryKey: key,
    queryFn: async () => {
      const res = await getAPLGrid(params);
      const { isSuccess, message, data } = res || {};

      if (isSuccess) {
        return data;
      } else {
        const errorMsg = message || 'Server Error';
        CustomNotification.error(errorMsg);
      }
    },
    ...rest,
  });
